import styled from '@emotion/styled';
import type {
  BorderColorProps,
  BorderRadiusProps,
  BorderStyleProps,
  BorderWidthProps,
  DisplayProps,
  MaxHeightProps,
  MaxWidthProps,
  MinWidthProps,
  SizeProps,
} from 'styled-system';
import {
  backgroundColor,
  borderColor,
  borderRadius,
  borderStyle,
  borderWidth,
  display,
  maxHeight,
  maxWidth,
  size,
} from 'styled-system';

import type { BackgroundColorProps } from '../../../../theme/system-types';
import type {
  AspectRatioProps,
  BoxSizingProps,
  CursorProps,
  ObjectFitProps,
} from '../../../../theme/system-utilities';
import { aspectRatio, boxSizing, cursor, objectFit } from '../../../../theme/system-utilities';
import { MAX_IMAGE_HEIGHT } from './constants';

type ImageStyleProps = DisplayProps &
  SizeProps &
  CursorProps &
  BoxSizingProps &
  ObjectFitProps &
  MaxWidthProps &
  MaxHeightProps &
  AspectRatioProps &
  BorderRadiusProps &
  BorderStyleProps &
  BackgroundColorProps &
  BorderColorProps &
  BorderWidthProps &
  MinWidthProps;

const ImageBase = styled.img<ImageStyleProps>`
  ${display};
  ${size};
  ${cursor};
  ${boxSizing};
  ${objectFit};
  ${maxWidth};
  ${maxHeight};
  ${aspectRatio};
  ${borderRadius};
  ${borderStyle};
  ${backgroundColor};
  ${borderColor};
  ${borderWidth};
`;

export const imageBaseStyles: Partial<ImageStyleProps> = {
  display: 'block',
  cursor: 'pointer',
  boxSizing: 'border-box',
  objectFit: 'contain',
  maxHeight: MAX_IMAGE_HEIGHT,
  aspectRatio: '1/1',
  borderRadius: 'medium',
  borderStyle: 'solid',
  size: ['58px', '54px', '94px', '109px'],
};

export type { ImageStyleProps };

export default ImageBase;
